/**
 * Created by fers on 23.05.16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl, defineMessages, IntlShape} from 'react-intl';
import ChannelIcon from "../../../channel-defs/ChannelIcon.react";
import urlMapping from '../../../app/URLMapping';
import types from '../../../../common/model-api/types';
import {Link} from 'react-router';
import config from '../../../../common/config';
import StatusIcon from '../StatusIcon.react';
import {getLocale} from '../../../locales';

const messages = defineMessages({
    help: {id: 'panel.requiredCaching.help', 'defaultMessage': 'More about caching functionality'},
});

class CachingRequired extends React.Component {
    static propTypes = {
        intl: PropTypes.object.isRequired,
        viewWithData: PropTypes.object,
    };

    render() {
        return (
            <div className="dativeryPlatformBox">
                <div className="dativeryPlatformTitle">
                    <div className={"channel-logo-32x32"}></div>
                </div>
                <div className="dativeryPlatformContent dativeryPlatformContentError">
                    <small><strong><i aria-hidden="true" className="fa fa-lg fa-exclamation-triangle" style={{color: '#f0ad4e'}}></i><FormattedMessage defaultMessage="Caching required" id="cachingRequired.title" /></strong></small>
                    <p>
                        <small>
                            <FormattedMessage defaultMessage="This feature requires caching of data in {productName}." id="cachingRequired.explanation" values={{productName: config.PRODUCT_NAME}}/>&nbsp;&nbsp;
                            <a href={"https://www.dativery.com/" + getLocale() + "/features/caching/"} target="_blank">
                                <StatusIcon reactTooltip title={this.props.intl.formatMessage(messages.help)} type={StatusIcon.HELP} />
                            </a>
                        </small>
                    </p>


                    <p>{this.props.viewWithData.cachingRequiredChannels.map((channel, idx) => {
                        let name = channel.name ? channel.name : channel.channelDef.name;

                        return (
                            <Link className="btn btn-default btn-sm" key={idx} target="_blank" to={config.PUBLIC_APP_URL + urlMapping.getUrl(types['channels'], 'caching', channel)}>
                                <ChannelIcon channelDef={channel.channelDef} size={32}/>{" "}
                                <FormattedMessage defaultMessage="Activate caching in {channelName}" id="cachingRequired.link" values={{channelName: name}}/>
                            </Link>
                        );
                    })}</p>
                </div>
            </div>
        );
    }
}

export default injectIntl(CachingRequired);
